import { Task } from '@bringg/types';

export const getDropOffWayPoint = (task: Partial<Task>) => {
	return task.way_points?.find(wp => wp.position === 2);
};
